import i18n from "../i18n";
import lodash from "lodash";
import { notification } from "ant-design-vue";
import { scrollToHasError, scrollToQuerySelector } from "./scroll";
import moment from "moment";

export const validateError = ({ error }) => {
    if (error?.errorFields?.length > 0) {
        notification["error"]({ message: i18n.global.t("error.form.invalid") });
        scrollToHasError();
    }
};

export const validateNotification = ({ message, querySelector }) => {
    if (message) {
        notification["error"]({ message });
        scrollToQuerySelector(querySelector);
    }
};

export const required = {
    validator: (rule, value) => {
        if (Array.isArray(value)) {
            if (value.filter(d => d.isDelete !== true).length === 0) {
                return Promise.reject(i18n.global.t("error.form.required"));
            }
        } else {
            if (value === undefined || value === null || value?.length === 0 || value?.toString()?.length === 0) {
                return Promise.reject(i18n.global.t("error.form.required"));
            }
        }
        return Promise.resolve();
    },
    required: true,
    trigger: "change"
};

export const requiredRichTextEditor = {
    validator: (rule, value) => {
        if (Array.isArray(value)) {
            if (value.filter(d => d.isDelete !== true).length === 0) {
                return Promise.reject(i18n.global.t("error.form.required"));
            }
        } else {
            if (value === undefined || value === null || value?.length === 0 || value?.toString()?.length === 0 || value === "<p><br></p>") {
                return Promise.reject(i18n.global.t("error.form.required"));
            }
        }
        return Promise.resolve();
    },
    required: true,
    trigger: "change"
};

export const requiredTrue = () => {
    return {
        validator: (rule, value) => {
            if (value != true) {
                return Promise.reject(i18n.global.t("error.form.required"));
            }
            return Promise.resolve();
        },
        required: true,
        trigger: "blur"
    };
};

export const email = {
    validator: (rule, value) => {
        const regExp = new RegExp("^.+@.+\\.\\w+$", "i");
        if (!regExp.test(value)) {
            return Promise.reject(i18n.global.t("error.form.email"));
        }
        return Promise.resolve();
    },
    trigger: "blur"
};

export const emails = {
    validator: (rule, value) => {
        const regExp = new RegExp("^.+@.+\\..+$", "i");
        if (!regExp.test(value)) {
            return Promise.reject(i18n.global.t("error.form.email"));
        }
        return Promise.resolve();
    },
    trigger: "blur"
};

export const requiredUsername = {
    validator: (rule, value) => {
        const regExp = new RegExp("^[A-Za-z@]+[A-Za-z\\d@_\\-\\.]{3,}$", "i");
        if (!regExp.test(value)) {
            return Promise.reject(i18n.global.t("error.form.username"));
        }
        return Promise.resolve();
    },
    required: true,
    trigger: "change"
};

export const dateLessThanOrEqualTo = date => {
    return {
        validator: (rule, value) => {
            if (value) {
                if (moment(value).isAfter(date)) {
                    return Promise.reject(i18n.global.t("error.form.dateLessThanOrEqualTo", { date: date.format("DD/MM/YYYY") }));
                }
            }
            return Promise.resolve();
        },
        trigger: "blur"
    };
};

export const thPid = {
    validator: (rule, value) => {
        if (value) {
            if (value.length !== 13) {
                return Promise.reject(i18n.global.t("error.form.pid"));
            }
            let sum = 0;
            for (let i = 0; i < 12; i++) {
                sum += parseFloat(value.charAt(i)) * (13 - i);
            }
            if ((11 - (sum % 11)) % 10 !== parseFloat(value.charAt(12))) {
                return Promise.reject(i18n.global.t("error.form.pid"));
            }
        }
        return Promise.resolve();
    },
    trigger: "blur"
};

export const equalsLength = equalsLength => {
    return {
        validator: (rule, value) => {
            if (value) {
                if (value.length !== equalsLength) {
                    return Promise.reject(i18n.global.t("error.form.equalsLength", { equals: equalsLength }));
                }
            }
            return Promise.resolve();
        },
        trigger: "blur"
    };
};

export const maxLength = maxLength => {
    return {
        validator: (rule, value) => {
            if (value) {
                if (value.length > maxLength) {
                    if (Array.isArray(value)) {
                        return Promise.reject(i18n.global.t("error.form.maxLengthArr", { max: maxLength }));
                    } else {
                        return Promise.reject(i18n.global.t("error.form.maxLength", { max: maxLength }));
                    }
                }
            }
            return Promise.resolve();
        },
        trigger: "blur"
    };
};

export const minLength = minLength => {
    return {
        validator: (rule, value) => {
            if (value) {
                if (value.length < minLength) {
                    if (Array.isArray(value)) {
                        return Promise.reject(i18n.global.t("error.form.minLengthArr", { min: minLength }));
                    } else {
                        return Promise.reject(i18n.global.t("error.form.minLength", { min: minLength }));
                    }
                }
            }
            return Promise.resolve();
        },
        trigger: "blur"
    };
};

export const keyDup = key => {
    return {
        validator: (rule, value) => {
            const obj = lodash.groupBy(value, key);
            const keyDup =
                Object.keys(obj)
                    .map(key => obj[key].length)
                    .filter(length => length > 1).length > 0;
            if (keyDup) {
                return Promise.reject(i18n.global.t("error.form.keyDup"));
            }
            return Promise.resolve();
        },
        trigger: "blur"
    };
};

export const same = (form, key, keyLabel, sameLabel) => {
    return {
        validator: (rule, value) => {
            const same = form[key] === value;
            if (!same) {
                return Promise.reject(i18n.global.t("error.form.same", { key: keyLabel, same: sameLabel }));
            }
            return Promise.resolve();
        },
        trigger: "blur"
    };
};

export const greaterThan = num => {
    return {
        validator: (rule, value) => {
            if (value) {
                if (parseFloat(value) <= num) {
                    return Promise.reject(i18n.global.t("error.form.greaterThan", { num: num }));
                }
            }
            return Promise.resolve();
        },
        trigger: "blur"
    };
};

export const greaterThanOrEqualTo = num => {
    return {
        validator: (rule, value) => {
            if (value) {
                if (parseFloat(value) < num) {
                    return Promise.reject(i18n.global.t("error.form.greaterThanOrEqualTo", { num: num }));
                }
            }
            return Promise.resolve();
        },
        trigger: "change"
    };
};

export const lessThanOrEqualTo = num => {
    return {
        validator: (rule, value) => {
            if (value) {
                if (parseFloat(value) > num) {
                    return Promise.reject(i18n.global.t("error.form.lessThanOrEqualTo", { num: num }));
                }
            }
            return Promise.resolve();
        },
        trigger: "change"
    };
};

export const quotaMustNotExceed = num => {
    return {
        validator: (rule, value) => {
            if (value) {
                if (parseFloat(value) > num) {
                    return Promise.reject(i18n.global.t("error.form.quotaMustNotExceed", { num: num }));
                }
            }
            return Promise.resolve();
        },
        trigger: "change"
    };
};

export const json = {
    validator: (rule, value) => {
        if (value) {
            try {
                JSON.parse(value);
            } catch (error) {
                return Promise.reject(i18n.global.t("error.form.json"));
            }
        }
        return Promise.resolve();
    },
    trigger: "blur"
};

export const requiredWhen = ({ when, requiredValidator }) => {
    return {
        validator: (rule, value) => {
            if (when?.({ rule, value })) {
                if (requiredValidator) {
                    const valid = requiredValidator({ rule, value });
                    if (valid?.then) {
                        return valid;
                    }
                    return valid ? Promise.resolve() : Promise.reject(i18n.global.t("error.form.required"));
                }
                return required.validator(rule, value);
            }
            return Promise.resolve();
        },
        trigger: "change",
        when
    };
};

export const requiredWithCheckbox = ({ checkbox }) => {
    return {
        validator: (rule, value) => {
            if (checkbox.value) {
                rule.required = true;
                return required.validator(rule, value);
            }
            rule.required = false;
            return Promise.resolve();
        },
        trigger: "change"
    };
};

export const geoojson = {
    validator: (rule, value) => {
        if (value) {
            const gjv = require("geojson-validation");
            if (!gjv.valid(value)) {
                return Promise.reject(i18n.global.t("error.form.geojson"));
            }
        }
        return Promise.resolve();
    },
    trigger: "blur"
};

export const geojsonLatlng = {
    validator: (rule, value) => {
        if (value) {
            const valueValidate = lodash.cloneDeep(value);
            valueValidate.coordinates = valueValidate.coordinates.map(d => parseFloat(d)).map(d => (isNaN(d) ? null : d));
            const gjv = require("geojson-validation");
            if (!gjv.valid(valueValidate)) {
                return Promise.reject(i18n.global.t("error.form.geojsonLatlng"));
            }
        }
        return Promise.resolve();
    },
    trigger: "blur"
};

export const clearRulesStartsWith = ({ useForm, key }) => {
    const { rulesRef, validateInfos } = useForm;
    Object.keys(validateInfos)
        .filter(k => k.startsWith(`${key}`))
        .forEach(k => delete validateInfos[k]);
    Object.keys(rulesRef)
        .filter(k => k.startsWith(`${key}`))
        .forEach(k => delete rulesRef[k]);
};

export const clearRules = ({ useForm, key }) => {
    const { rulesRef, validateInfos } = useForm;
    Object.keys(validateInfos)
        .filter(k => k == key)
        .forEach(k => delete validateInfos[k]);
    Object.keys(rulesRef)
        .filter(k => k == key)
        .forEach(k => delete rulesRef[k]);
};

export const clearDatas = ({ useForm, key }) => {
    const { modelRef } = useForm;
    if (key in modelRef) {
        modelRef[key] = null;
    }
};

export const addRules = ({ useForm, modelRef, key, defaultValue = null, rules, promise = true, isSet = true }) => {
    const { validateInfos, rulesRef } = useForm;
    if (promise) {
        Promise.resolve()
            .then(() => {
                if (isSet && (lodash.get(modelRef, `${key}`) === undefined || lodash.get(modelRef, `${key}`) === null)) {
                    lodash.set(modelRef, `${key}`, defaultValue);
                }
            })
            .then(() => {
                validateInfos[`${key}`] = { autoLink: false, required: rules.filter(d => d.required).length > 0 };
                rulesRef[`${key}`] = rules;
            });
    } else {
        if (isSet && (lodash.get(modelRef, `${key}`) === undefined || lodash.get(modelRef, `${key}`) === null)) {
            lodash.set(modelRef, `${key}`, defaultValue);
        }
        validateInfos[`${key}`] = { autoLink: false, required: rules.filter(d => d.required).length > 0 };
        rulesRef[`${key}`] = rules;
    }
};
